<template>
  <div class="loading-container">
    <b-spinner variant="primary" :style="{ width: '80px', height: '80px' }" />
  </div>
</template>

<script>
export default {
  mounted() {
    this.$store
      .dispatch('auth/getProfile')
      .then((user) => {
        if (user.role === 'Admin') {
          this.toRoute('admin.agencies.index')
        } else if (user.role === 'Agency') {
          if (user.hasCourses) {
            this.toRoute('agency.courses.index')
          } else {
            this.toRoute('agency.websites.index')
          }
        } else if (['AgencyUser', 'WebsiteUser'].includes(user.role)) {
          this.toRoute('agency.websites.index')
        }
      })
      .catch(() => this.toRoute('login'))
  },
  methods: {
    toRoute(name) {
      this.$router.push({ name }).catch(() => {})
    }
  }
}
</script>